<template>
  <div>
    <Card>
      <Row>
        <Col span="4">{{$t('pages_sms_notes_index_1123', [ shop.sms_quantity ])}}</Col>
        <Col span="6">
          <Button type="info" @click="add">{{$t('pages_sms_notes_index_1124')}}</Button>
        </Col>
      </Row>
      <TablePaginate
        :columns="columns"
        :data="sms_notes"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
    <Modal v-model="modalShow" @on-ok="handleSubmit" :title="$t('pages_sms_notes_index_1125')">
      <Form ref="sms_charge" :model="sms_charge" :label-width="80">
        <Form-item :label="$t('pages_sms_notes_index_1126')" prop="sms_charge_id">
          <Select label-in-value v-model='sms_charge.sms_charge_id'>
            <Option
              v-for="item in sms_charges"
              :value="item.id"
              :key="item.id"
              >{{$t('pages_sms_notes_index_1127', [ item.price , item.quantity ])}}</Option
            >
          </Select>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      modalShow: false,
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: i18n.t('pages_customers_index_313'),
          width: 260,
          key: 'fresh_customer_mobile'
        },
        {
          title: i18n.t('pages_feedbacks_index_500'),
          key: 'content'
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          key: 'created_at_str',
          width: 200,
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
    this.show(localStorage.getItem('SHOPID'))
    this.getChargeTemplates()
  },
  computed: {
    ...mapGetters('sms_note', ['sms_notes', 'meta', 'loading']),
    ...mapGetters('shop', ['shop']),
    ...mapGetters('sms_charge', ['sms_charges', 'sms_charge'])
  },
  methods: {
    ...mapActions('sms_note', ['index']),
    ...mapActions('shop', ['show']),
    ...mapActions('sms_charge', { getChargeTemplates: 'index', clear: 'clear' }),
    ...mapActions('balance_transaction', ['create']),
    ...mapMutations('sms_note', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
    },
    handleSubmit () {
      this.create(this.sms_charge).then(result => this.show(localStorage.getItem('SHOPID')))
    }
  }
}
</script>
